import React, { useState, useEffect } from "react";
import FinanzChart from "../FinanzChart";
import { getBookings } from "../../services/azureBookingService";
import { getBudgetProjections } from "../../services/azureBudgetService";

const FinanzChartWidget = () => {
  const [bookings, setBookings] = useState([]);
  const [budgetProjections, setBudgetProjections] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const [b, p] = await Promise.all([
          getBookings(),
          getBudgetProjections(),
        ]);
        setBookings(b || []);
        setBudgetProjections(p || []);
      } catch (err) {
        console.error("FinanzChartWidget Ladefehler:", err);
      }
    };
    load();
  }, []);

  return (
    <div className="widget-content-scroll">
      <FinanzChart bookings={bookings} budgetProjections={budgetProjections} />
    </div>
  );
};

export default FinanzChartWidget;
